export enum OrderCode {
    NEW_REQUEST = "NEW_REQUEST",
    AFTER_SALES_SERVICE = "AFTER_SALES_SERVICE",
}
export enum OrderLabel {
    NEW_CUSTOMER_ORDER = "Nouvelle commande client"
}